import { useTranslation } from "react-i18next";
import { OrderLine } from "@beeldit/ecommerce/orders/models/Order";
import React from "react";
import { Link } from "react-router-dom";

interface Prop {
  orderLine: OrderLine;
  showMarketplaceCommission?: boolean;
}

function OrderLineDetails(props: Prop) {
  const { orderLine, showMarketplaceCommission = false } = props;
  const { t } = useTranslation();

  const mainImage = orderLine.combination.gallery?.find(
    (element) => element.main
  );

  const formatPrice = (price: number) =>
    new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
    }).format(price);

  // Calculamos desglose por unidad y por cantidad
  const totalNetPrice = orderLine.net_price || 0;
  const totalTax = orderLine.tax || 0;
  const totalDiscount = orderLine.discount || 0;

  // Calculamos la comisión del marketplace
  // Usamos any para acceder a producer_amount que puede venir del backend
  const orderLineAny = orderLine as any;
  const marketplaceCommission = orderLine.commission_amount;

  return (
    <tr>
      <td className="product">
        <div className="product-data">
          <div className="product-thumb">
            {mainImage && (
              <img
                src={
                  mainImage.img[0].thumb_url
                    ? process.env.REACT_APP_API_URL_IMG +
                      mainImage.img[0].thumb_url
                    : process.env.REACT_APP_API_URL_IMG + mainImage.img[0].url
                }
                alt={mainImage.img[0].filename}
              />
            )}
          </div>
          <div className="product-name">
            <Link
              to={`/panel/1/1/products/${orderLine.combination.product_id}`}
            >
              <strong className="d-block">
                {orderLine.combination.name.es}
              </strong>
              <small>{orderLine.combination.sku}</small>
            </Link>
          </div>
        </div>
      </td>

      <td data-label={t("producer")}>
        <Link
          to={`/panel/1/1/producers/${orderLine.combination.product.producer_id}`}
        >
          {orderLine.combination.product.producer.user.name}{" "}
          {orderLine.combination.product.producer.user.surnames}
        </Link>
      </td>

      <td data-label={t("quantity")} className="qty">
        {orderLine.quantity}
      </td>

      {/* ✅ Precio base sin IVA (neto + descuento) */}
      <td data-label={t("subtotal")} className="currency">
        {formatPrice(totalNetPrice + totalDiscount)}
      </td>
      {/* ✅ Descuento */}
      <td data-label={t("discount")} className="currency text-danger">
        - {formatPrice(totalDiscount)}
      </td>
      {/* ✅ IVA */}
      <td data-label={t("tax")} className="currency">
        {formatPrice(totalTax)}
      </td>

      {/* ✅ Total */}
      <td data-label={t("total")} className="currency">
        {formatPrice(orderLine.total_price)}
      </td>

      {/* ✅ Comisión Marketplace - Solo para admins */}
      {showMarketplaceCommission && (
        <td data-label={t("commission_amount")} className="currency">
          {formatPrice(marketplaceCommission)}
        </td>
      )}
    </tr>
  );
}

export default OrderLineDetails;
